import { render, staticRenderFns } from "./mermas.vue?vue&type=template&id=0230135a&scoped=true"
import script from "./mermas.vue?vue&type=script&lang=js"
export * from "./mermas.vue?vue&type=script&lang=js"
import style0 from "./mermas.vue?vue&type=style&index=0&id=0230135a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0230135a",
  null
  
)

export default component.exports